import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromInvite from '../reducers/invite.reducer';

export const selectFeatureState = createFeatureSelector<fromInvite.State>(fromInvite.featureKey);

export const {
  selectIds: selectInviteIds,
  selectEntities: selectInviteEntities,
  selectAll: selectAllInvites,
  selectTotal: selectTotalInvites
} = fromInvite.adapter.getSelectors(selectFeatureState);
export const selectInvitesCount = createSelector(selectFeatureState, ({ ids }) => ids.length);
export const selectInvitesLoading = createSelector(selectFeatureState, ({ loading }) => !!loading);
export const selectInviteMember = createSelector(selectFeatureState, ({ inviteMember }) => inviteMember);
export const selectInviteMemberCode = createSelector(selectInviteMember, ({ code }) => code);
